import { CurrencyTypeUppercase } from "../../constants/currency";
import { OptionMap } from "../../helpers/optionMap";
import {
  FleetExpensesTransport,
  FleetExpensesTransportId,
} from "./FleetExpensesTransport";
import { FleetExpensesSpendingType } from "./FleetExpensesSpendingType";
import { Nullable } from "../Common";

const paymentTypes = {
  "By Cash": "Cash",
  "By Card": "Card",
} as const;
export type PaymentType = keyof typeof paymentTypes;
export const fleetExpensePaymentTypeMap = new OptionMap<PaymentType>(
  paymentTypes
);

export type FleetExpenseId = number;

export type FleetExpensesDriver = {
  id: number;
  name: string;
};

export type FleetExpensesCard = {
  id: number;
  number: string;
};

export type FleetDriver = {
  id: number;
  last_name: string;
  first_name: string;
  name: string;
  card: FleetExpensesCard | null;
};

export type FleetCardAssignment = {
  id: number;
  driver_id: number;
  card: FleetExpensesCard;
  starts_at: string;
  ends_at: string | null;
};

const fleetExpenseRowTypes = [
  "driver",
  "tc",
  "spending-type",
  "expense",
] as const;
export type FleetExpenseRowType = typeof fleetExpenseRowTypes[number];

export type FleetExpensesModel<Type extends FleetExpenseRowType> = {
  driver: FleetExpensesDriver;
  card: FleetExpensesCard | null;
  type: Type;
} & (Type extends "driver"
  ? {
      children: FleetExpensesModel<"tc">[];
    }
  : Type extends "tc"
  ? {
      tc: FleetExpensesTransport;
      children: FleetExpensesModel<"spending-type">[];
    }
  : Type extends "spending-type"
  ? {
      tc: FleetExpensesTransport;
      spendingType: FleetExpensesSpendingType;
      children: FleetExpensesModel<"expense">[];
    }
  : Type extends "expense"
  ? {
      id: FleetExpenseId;
      card_assignment_id: Nullable<number>;
      tc: FleetExpensesTransport;
      spendingType: FleetExpensesSpendingType;
      date: string;
      amount: number;
      currency: CurrencyTypeUppercase;
      paymentType: PaymentType;
      note: string;
    }
  : never);

export type FleetExpensesModelAny =
  | FleetExpensesModel<"driver">
  | FleetExpensesModel<"tc">
  | FleetExpensesModel<"spending-type">
  | FleetExpensesModel<"expense">;

export type FleetExpenseParameters = {
  driver_id: number;
  tc_id: FleetExpensesTransportId;
  spending_type_id: number;
  date: Date | string;
  amount: number;
  currency: CurrencyTypeUppercase;
  payment_type: PaymentType;
  card_assignment_id?: number;
  note: string;
};

export type FleetExpenseResponseData = FleetExpensesModel<"expense">;

export type FleetExpenseAction = (
  expense: Nullable<FleetExpensesModel<"expense">>
) => void;
